import { Dispatch, Store } from "redux";
import store from "..";
import { CALL_API } from "../api.middleware";
import {
  CartItemsMap,
  CartResponse,
  FrequencyOptions,
  GET_CART_ITEMS_LIST,
  GET_CART_ITEMS_LIST_SUCCESS,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_TRANSACTION_DATA,
  GET_TRANSACTION_DATA_SUCCESS,
  InvestorDetails,
  Options,
  REQ_BY,
  SipSchemeOptions,
  SwitchInOptions,
  SwitchInSchemesResponse,
  TransactionHistoryTable,
  TransactionType,
  YES,
} from "../types";
import { handleError, isNotAotm } from "../../utils/cart";
import { swpOptions } from "./transactions";
import moment from "moment";

export interface BankDetailsResponse {
  Table: Table[];
  Table1: Table1[];
}

export interface Table {
  Error_Code: number;
  Error_Message: string;
  EncryptionFlag: string;
}

export interface Table1 {
  Fund: string;
  foliono: string;
  bnkname: string;
  bnkactype: string;
  bnkacno: string;
  defaultbnk: string;
  ifsccode: string;
}

interface STPGap {
  fund: string;
  frequency: string;
  scheme: string;
}

export const getMinTatStp =
  ({ frequency, fund, scheme }: STPGap) =>
  async (dispatch: any) => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: `/Ktrack_getmingap`,
          params: {
            Frequency: frequency,
            Fund: fund,
            Scheme: scheme,
            trtype: "STP",
          },
          method: "GET",
        },
      });
      const { DtData } = response;
      const [gap] = DtData;
      const { Mingap } = gap;
      return Mingap;
    } catch (error) {
      handleError(error);
    }
  };

export const getRedemptionBankDetails =
  (fundCode: string, folio: string) =>
  async (dispatch: any): Promise<BankDetailsResponse> => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/GetRedemptionBankDeatils",
          params: { Acno: folio, Fund: fundCode, Trtype: "" },
          method: "GET",
        },
      });
    } catch (error) {
      alert(`${error}`);
    }
  };

export const getCartCount =
  (distributorId: string) => async (dispatch: any) => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/cart/get-cart-count",
          method: "POST",
          body: { distributorId },
          isCart: true,
          showLoader: true,
        },
      });
    } catch (error) {
      alert(error);
    }
  };

export const addItemsToCart = (payload: any) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: `/cart/add`,
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
    return response;
  } catch (error) {
    handleError(error);
  }
};

export const getAmcMasters =
  () =>
  async (dispatch: any): Promise<Options> => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: `/getMasterSIP`,
          method: "GET",
          showLoader: true,
          params: { opt: "A" },
        },
      });
      const { Dtinformation = [] } = response;

      return Dtinformation.map(
        (fund: { amc_code: string; amc_name: string }) => {
          return { value: String(fund.amc_code), label: fund.amc_name };
        }
      );
    } catch (error) {
      alert(error);
    }
  };

export const getNewPurchaseCategory =
  (fund: string) =>
  async (dispatch: any): Promise<Options> => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/getMasterNewpur",
          method: "GET",
          params: {
            fund,
            opt: "AT",
          },
        },
      });

      const { Dtinformation = [] } = response;

      return Dtinformation.map((category: { fm_subcategory: string }) => {
        return {
          label: category.fm_subcategory,
          value: category.fm_subcategory?.trim(),
        };
      });
    } catch (error) {
      alert(error);
    }
  };

export const getSipCategory =
  (fund: string, folio?: string) =>
  async (dispatch: any): Promise<Options> => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/GetAssetclass",
          method: "GET",
          params: { Fund: fund, Folio: folio },
        },
      });

      const { DtData = [] } = response as {
        DtData: Array<{ CatValue: string; CatDesc: string }>;
      };

      return DtData.map(({ CatValue, CatDesc }) => {
        return {
          label: CatDesc,
          value: CatValue,
        };
      });
    } catch (error) {
      alert(error);
    }
  };

export const CalcSIPEnddt =
  (params: any) =>
  async (dispatch: Dispatch<any>): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: "/CalcSIPEnddt",
        params,
        method: "GET",
      },
    });
  };

export const getInvestorDetailsByPan =
  (pan: string) =>
  async (dispatch: any): Promise<InvestorDetails> => {
    try {
      const {
        authReducer: { userId },
      } = (store as Store).getState();

      const response = await dispatch({
        [CALL_API]: {
          url: "/GetDistributorDetailsbyPAN",
          params: {
            ReqBy: REQ_BY,
            Uid: userId,
            PAN: pan,
          },
          method: "GET",
          showLoader: true,
          types: ["GET_INVESTOR_DETAILS", "GET_INVESTOR_DETAILS_SUCCESS"],
        },
      });

      return response;
    } catch (error) {
      alert(error);
    }
  };

export const getSipSchemes =
  ({
    fundCode,
    category,
    acno = "0",
  }: {
    fundCode: string;
    category: string;
    acno: string | number;
  }) =>
  async (dispatch: any): Promise<SipSchemeOptions> => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/getOtherSchemesSwitch",
          method: "GET",
          params: {
            category,
            acno,
            fundCode,
            trantype: "I",
            schtype: "Regular",
          },
          enableFixture: false,
          json: "sipSchemes.json",
        },
      });

      const { DtData = [] } = response;
      return DtData?.map(
        (scheme: {
          fm_fund: string;
          fm_scheme: string;
          fm_plan: string;
          fm_option: string;
          fm_schdesc: string;
          fm_plnmode: string;
          fm_newpur: string;
          KYC: string;
          SIPminamt: string;
          multiples: number;
        }) => {
          return {
            label: scheme.fm_schdesc,
            value: scheme.fm_schdesc,
            plan: scheme.fm_plan,
            option: scheme.fm_option,
            scheme: scheme.fm_scheme,
            sipMinAmount: scheme.SIPminamt,
            newPurchaseMinAmount: scheme.fm_newpur,
            multiples: scheme.multiples,
            ...scheme,
          };
        }
      );
    } catch (error) {
      alert(error);
    }
  };

export const getSipFrequency =
  (fund: string, scheme: string, plan: string) =>
  async (dispatch: any): Promise<FrequencyOptions> => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/getMasterSIP",
          method: "GET",
          params: {
            fund,
            opt: "IF",
            scheme,
            plan,
          },
        },
      });
      const { Dtinformation = [] } = response;

      return Dtinformation.map(
        ({
          FrequencyID,
          FrequencyDescription,
          Minimum_Instalment,
        }: {
          [key: string]: string;
        }) => {
          return {
            label: FrequencyDescription,
            value: FrequencyID,
            minimumInstallments: Minimum_Instalment,
          };
        }
      );
    } catch (error) {
      alert(error);
    }
  };

export const getSipDayList =
  (fund: string, astScheme: string) =>
  async (dispatch: any): Promise<Options> => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/getMasterSIP",
          method: "GET",
          params: {
            fund,
            opt: "D",
            astscheme: astScheme,
          },
        },
      });
      const { Dtinformation = [] } = response;
      return Dtinformation?.map(({ sip_cycleid }: { sip_cycleid: number }) => {
        return {
          label: String(sip_cycleid),
          value: String(sip_cycleid),
        };
      });
    } catch (error) {}
  };

export const getNewPurchaseSchemes =
  ({ fund, schemetype }: { fund: string; schemetype: string }) =>
  async (dispatch: any) => {
    try {
      const response: NewPUrchaseResponse = await dispatch({
        [CALL_API]: {
          url: "/getMasterNewpur",
          method: "GET",
          params: {
            opt: "S",
            plntype: "Regular",
            fund,
            schemetype,
          },
          enableFixture: false,
          json: "newPurchaseSchemes.json",
        },
      });

      const { Dtinformation = [] } = response;

      return Dtinformation.filter(
        (schemeDetails) => schemeDetails.PlanDesc.toUpperCase() === "REGULAR"
      ).map((schemeDetails) => {
        const { Scheme_Plan, Scheme_Desc, MinAmt, multiples, ...rest } =
          schemeDetails;
        const [_, scheme = "", plan = "", option = ""] =
          Scheme_Plan?.split("~");
        return {
          label: Scheme_Desc,
          value: Scheme_Plan,
          minAmount: MinAmt,
          multiples,
          scheme,
          plan,
          option,
          ...rest,
        };
      });
    } catch (error) {
      alert(error);
    }
  };

export const cartCheckout: CartCheckout = function (args) {
  return async (dispatch: any) => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/cart/checkout",
          isCart: true,
          body: args,
          method: "POST",
        },
      });
    } catch (error) {
      alert(error);
    }
  };
};
export const checkoutNewPurchase = (payload: any) => async (dispatch: any) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/cart/checkout",
        isCart: true,
        body: payload,
        method: "POST",
      },
    });
  } catch (error) {
    handleError(error);
    if (error instanceof Error) {
      throw new Error(error.message);
    }
  }
};

export const getInvestorDetails =
  ({ pan, Uid }: { pan: string; Uid: string }) =>
  async (dispatch: any) => {
    try {
    } catch (error) {
      alert(error);
    }
  };

export const clearCartItems = () => (dispatch: any) =>
  dispatch({ type: "CLEAR_CART" });

export const getCartItemsList =
  (payload: { arnCode: string; pan: string }) => async (dispatch: any) => {
    try {
      const response: CartResponse = await dispatch({
        [CALL_API]: {
          url: "/cart/list-items",
          method: "POST",
          showLoader: true,
          body: payload,
          isCart: true,
          types: [GET_CART_ITEMS_LIST, GET_CART_ITEMS_LIST_SUCCESS],
        },
      });
      return response;
    } catch (error) {
      alert(`${error}`);
    }
  };

export const checkPAN = (payload: any) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: "/transactions/pan-aadhar-seeding",
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
    return response;
  } catch (error) {
    alert(`${error}`);
  }
};
export const validateNomineeDetails = (payload: any) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: "/transactions/validate-nominee-details",
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
    return response;
  } catch (error) {
    alert(`${error}`);
  }
};
export const updateCartItem = (payload: any) => async (dispatch: any) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/cart/modify",
        method: "PUT",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const deleteCartItem = (payload: any) => async (dispatch: any) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/cart/remove-cart-item",
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const clearCart = (payload: any) => async (dispatch: any) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/cart/clear",
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export interface CartItem {}

export const getWithdrawalOptions =
  (fundCode: string) =>
  async (dispatch: any): Promise<Options> => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/getMasterSIP",
          params: { opt: "SWPW", fund: fundCode },
          method: "GET",
        },
      });
      return response.Dtinformation.map(({ code, Description }: any) => ({
        label: Description,
        value: code,
      }));
    } catch (error) {
      alert(error);
    }
  };

export const getWithdrawalFrequency =
  (fundCode: string) =>
  async (
    dispatch: any
  ): Promise<
    { minimumInstallments: string; label: string; value: string }[]
  > => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/getMasterSIP",
          params: { opt: "SWF", fund: fundCode },
          method: "GET",
        },
      });
      return response.Dtinformation.map(
        ({ FrequencyID, FrequencyDescription, Minimum_Instalment }: any) => ({
          label: FrequencyDescription,
          value: FrequencyID,
          minimumInstallments: Minimum_Instalment,
        })
      );
    } catch (error) {
      alert(error);
    }
  };

export const getStpFrequency =
  (fundCode: string) =>
  async (
    dispatch: any
  ): Promise<
    { label: string; value: string; minimumInstallments: number }[]
  > => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/getMasterSIP",
          params: { opt: "SF", fund: fundCode, astscheme: "" },
          method: "GET",
        },
      });
      return response.Dtinformation.map(
        ({ FrequencyID, FrequencyDescription, Minimum_Instalment }: any) => ({
          label: FrequencyDescription,
          value: FrequencyID?.toUpperCase(),
          minimumInstallments: Minimum_Instalment,
        })
      );
    } catch (error) {
      alert(error);
    }
  };

export const getSwpDayOptions =
  (fundCode: string, frequency: string) =>
  async (dispatch: any): Promise<Options> => {
    const response = await dispatch({
      [CALL_API]: {
        url: "/getMasterSIP",
        params: { opt: "SWPD", fund: fundCode, Astscheme: frequency },
        method: "GET",
      },
    });
    return response.Dtinformation.map(({ sip_cycleid, TAT }: any) => ({
      label: sip_cycleid,
      value: sip_cycleid,
    }));
  };

export const getDashboardStats =
  () =>
  async (
    dispatch: any
  ): Promise<{ pending: number; expired: number; approved: number }> => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/dashboard/orders/stats",
          method: "GET",
          isCart: true,
          types: [GET_TRANSACTION_DATA, GET_DASHBOARD_DATA_SUCCESS],
        },
      });
    } catch (error) {
      alert(error);
    }
  };

export const getStpDayOptions =
  (fundCode: string, frequency: string) =>
  async (dispatch: any): Promise<Options> => {
    const response = await dispatch({
      [CALL_API]: {
        url: "/getMasterSIP",
        params: { opt: "STPD", fund: fundCode, astscheme: frequency },
        method: "GET",
      },
    });
    return response.Dtinformation.map(({ sip_cycleid, TAT }: any) => ({
      label: sip_cycleid,
      value: sip_cycleid,
    }));
  };

export const getTransactionsTable =
  (status: "P" | "A" | "E") =>
  async (dispatch: any): Promise<TransactionHistoryTable> => {
    const { token } = store.getState().authReducer;
    try {
      const response: TransactionHistoryTable = await dispatch({
        [CALL_API]: {
          url: "/dashboard/orders",
          params: { transflag: status, Arn: token },
          method: "GET",
          isCart: true,
          isAuthTable: true,
          types: [GET_TRANSACTION_DATA, GET_TRANSACTION_DATA_SUCCESS],
          json: "tableData.json",
          showLoader: false,
        },
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  };

export const getSwitchInSchemesList =
  ({
    folio,
    fundCode,
    category,
  }: {
    folio: string | number;
    fundCode: string;
    category: string;
  }) =>
  async (dispatch: any): Promise<SwitchInOptions> => {
    try {
      const response: SwitchInSchemesResponse = await dispatch({
        [CALL_API]: {
          url: "/getOtherSchemesSwitch",
          params: {
            category,
            fundCode,
            acno: folio,
            schtype: "Regular",
            trantype: "S",
          },
          method: "GET",
        },
      });

      return response.DtData.map(({ fm_schdesc, ...rest }) => ({
        label: fm_schdesc,
        value: fm_schdesc,
        ...rest,
      }));
    } catch (error) {
      alert(`${error}`);
    }
  };

export const getStpSchemesList =
  ({
    folio,
    fundCode,
    category,
  }: {
    folio: string | number;
    fundCode: string;
    category: string;
  }) =>
  async (dispatch: any): Promise<SwitchInOptions> => {
    try {
      const response: SwitchInSchemesResponse = await dispatch({
        [CALL_API]: {
          url: "/getOtherSchemesSwitch",
          params: {
            category,
            fundCode,
            acno: folio,
            schtype: "Regular",
            trantype: "T",
          },
          method: "GET",
        },
      });

      return response.DtData.map(({ fm_schdesc, ...rest }) => ({
        label: fm_schdesc,
        value: fm_schdesc,
        ...rest,
      }));
    } catch (error) {
      alert(`${error}`);
    }
  };
export const getAdditionalPurchaseSchemes =
  ({
    folio,
    fundCode,
    category,
  }: {
    folio: string | number;
    fundCode: string;
    category: string;
  }) =>
  async (dispatch: any): Promise<SwitchInOptions> => {
    try {
      const response: SwitchInSchemesResponse = await dispatch({
        [CALL_API]: {
          url: "/getOtherSchemesSwitch",
          params: {
            category,
            fundCode,
            acno: folio,
            schtype: "Regular",
            trantype: "P",
          },
          method: "GET",
          enableFixture: false,
          json: "additionalPrchaseSchemes.json",
        },
      });

      return response.DtData.map(({ fm_schdesc, ...rest }) => ({
        label: fm_schdesc,
        value: fm_schdesc,
        ...rest,
      }));
    } catch (error) {
      alert(`${error}`);
    }
  };

export const reinitate =
  <T extends TransactionType>(ihno: string) =>
  async (dispatch: any): Promise<CartItemsMap[T]> => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/dashboard/orders/re-initiate",
          method: "POST",
          body: { ihno },
          isCart: true,
        },
      });
      return response.response;
    } catch (error) {
      alert(error);
    }
  };

export const getUmrnList: GetUmrn =
  ({ fund, pan, folio, modeOfRegistration }) =>
  async (dispatch) => {
    try {
      const url =
        modeOfRegistration === "AOTM" ? "/CheckPANAotm" : "/CheckPANKotm";
      const response: UmrnRespone = await dispatch({
        [CALL_API]: {
          url,
          params: {
            Fund: fund,
            Acno: folio || 0,
            PAN: pan,
          },
          method: "GET",
        },
      });
      const { Table1 = [] } = response;
      return Table1.map(mapUmrnResponse);
    } catch (error) {
      console.error(error);
      return [];
    }
  };

export const addToCart =
  (requestBody: AddToCartFromHistory) =>
  async (dispatch: any): Promise<{ message: string; pan: string }> => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/dashboard/orders/add-to-cart",
          method: "POST",
          body: requestBody,
          isCart: true,
        },
      });
    } catch (error: any) {
      console.error(error);
      if ("message" in error) {
        throw new Error(error.message);
      }
    }
  };

export const getLumpsumPaymodes =
  (
    fund: string,
    pan: string,
    trType?: "APL" | "SIN",
    folio?: string | number
  ) =>
  async (dispatch: any) => {
    try {
      const paymodesResponse = (
        await getPaymentOptions(fund, trType)(dispatch)
      ).map(({ value }) => value);
      const registrationOptionsResponse = await swpOptions({
        opt: "PM",
        Fund: fund,
        astscheme: pan,
        acno: folio,
      })(dispatch);
      const registrationOptions = registrationOptionsResponse.Dtinformation.map(
        (p: any) => p.Pay_Mode
      );
      const uniquePaymentModes = Array.from(
        new Set(paymodesResponse.concat(registrationOptions))
      ).map((s) => ({ label: s.toUpperCase(), value: s.toUpperCase() }));
      return uniquePaymentModes
        .filter((mode) => mode.value !== "ISIP")
        .filter((o) => {
          if (fund !== "129") return true;
          return isNotAotm(o);
        });
    } catch (e) {
      handleError(e);
    }
  };

export const checkAotmStatus = (fund: string) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: "/transactions/get-aotm-details",
        method: "POST",
        body: { fund },
        isCart: true,
      },
    });
    const { enach_aotm_basedon } = response;
    return enach_aotm_basedon.toUpperCase() === "PAN";
  } catch (error) {
    handleError(error);
  }
};

export const getPaymentOptions =
  (fund: string, transactionType?: "APL" | "SIPN" | "SIN" | "NPL") =>
  async (dispatch: any) => {
    try {
      const arnCode = store.getState().authReducer.token;
      const isPioEnabled =
        arnCode === process.env.REACT_APP_BOB_ARN_CODE &&
        fund === process.env.REACT_APP_BOB_FUND_CODE &&
        ["APL", "SIN"].includes(transactionType);
      const response = await dispatch({
        [CALL_API]: {
          url: "/transactions/approve-amc-otm-upis",
          method: "POST",
          body: { fund },
          isCart: true,
          showLoader: true,
        },
      });
      return Object.keys(response)
        .filter(
          (paymentOption) =>
            response[paymentOption].toUpperCase() === "Y" &&
            !["fund", "name"].includes(paymentOption)
        )
        .map((paymentOption) => ({
          label: paymentOption.toUpperCase(),
          value: paymentOption.toUpperCase(),
        }))
        .filter(({ value }) => value !== "ISIP")
        .concat(
          isPioEnabled
            ? [
                {
                  label: "BOB-PIO PaymentMode",
                  value: "PIO",
                },
              ]
            : []
        );
    } catch (error) {
      alert(error);
    }
  };
export const validateSubBroker =
  ({
    arnCode,
    fundCode,
    subArnCode,
  }: {
    arnCode: string;
    fundCode: string;
    subArnCode: string;
  }) =>
  async (dispatch: any): Promise<Options> => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/ValidateBrokercode",
          params: { Fund: fundCode, SubAgentCd: subArnCode, AgentCd: arnCode },
        },
        method: "GET",
      });
      const { DtData } = response;
      return DtData.map(({ abm_name, abm_agent }: { [x: string]: string }) => ({
        label: abm_agent,
        value: abm_name,
      }));
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      }
      if (typeof error === "string") {
        throw new Error(error);
      }
    }
  };

export const getInvestorCategory =
  (fund: string, folio: string) => async (dispatch: any) => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/transactions/get-investor-category",
          body: {
            fund,
            folio,
          },
          isCart: true,
          method: "POST",
        },
      });
    } catch (error) {
      handleError(error);
    }
  };

interface Args
  extends Array<{
    cartItemId: string;
    mode: "ISIP" | "KOTM" | "AOTM" | "";
  }> {}

export const updateIsipCart = (args: Args) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: "/cart/change-to-isip",
        body: { items: args, modeOfRegistration: args[0].mode },
        isCart: true,
        method: "POST",
      },
    });
    const { cartItems } = response;
    dispatch({
      type: GET_CART_ITEMS_LIST_SUCCESS,
      body: { cartItems },
    });
    return cartItems;
  } catch (error) {
    handleError(error);
  }
};

export const validateSipDates = function (args: {
  startDate: Date;
  endDate: Date;
  fund: string;
  scheme: string;
  frequency: string;
  trType: "SIP" | "STP";
}) {
  return async function (dispatch: any) {
    const payload = {
      startDate: moment(args.startDate).format("MM/DD/YYYY"),
      endDate: moment(args.endDate).format("MM/DD/YYYY"),
      fund: args.fund,
      frequency: args.frequency,
      scheme: args.scheme,
      TRtype: args.trType,
    };
    return await dispatch({
      [CALL_API]: {
        url: "/transactions/validate-dates",
        method: "POST",
        isCart: true,
        body: payload,
      },
    });
  };
};
export const getTat = function (args: {
  fund: string;
  scheme: string;
  freq: string;
  modeOfRegistration?: "ISIP" | "AOTM" | "KOTM";
  trType: "SIP" | "STP";
}) {
  return async function (dispatch: any) {
    const payload = {
      fund: args.fund,
      freq: args.freq,
      scheme: args.scheme,
      trType: args.trType,
    };
    const response = await dispatch({
      [CALL_API]: {
        url: "/transactions/otm-isip-tat",
        method: "POST",
        isCart: true,
        body: payload,
      },
    });
    const { sci_mingap_enach_otm, sci_mingap_isip } = response;
    if (args.modeOfRegistration === "ISIP") return Number(sci_mingap_isip);
    return Number(sci_mingap_enach_otm);
  };
};

interface GetFreedomSipCategory {
  (args: { fund: string }): (dispatch: any) => Promise<any>;
}

export const getFreedomSipCategories: GetFreedomSipCategory = function (args) {
  return async function (dispatch: any) {
    const response = await dispatch({
      [CALL_API]: {
        url: "/FreedomSIPSWPschemes",
        method: "GET",
        params: {
          fund: args.fund,
          plnmode: "Regular",
        },
      },
    });
    const { DtData = [] } = response;
    return DtData.map((o: any) => ({
      label: o.category,
      value: o.category,
    }));
  };
};

interface GetFreedomSipSchemes {
  (args: { fund: string; category: string }): (dispatch: any) => Promise<any>;
}

export const getFreedomSipSchemes: GetFreedomSipSchemes = function (args) {
  return async function (dispatch: any) {
    const response = await dispatch({
      [CALL_API]: {
        url: "/FreedomSIPSWPschemes",
        method: "GET",
        params: {
          fund: args.fund,
          plnmode: "Regular",
          category: args.category,
        },
      },
    });
    const { DtData = [] } = response;
    return DtData.map((schemeDetails: any) => {
      const { fm_Scheme, fm_plan, fm_option, freedom_sip_min_amt, sch_desc } =
        schemeDetails;
      return {
        label: sch_desc,
        value: sch_desc,
        scheme: fm_Scheme,
        plan: fm_plan,
        option: fm_option,
        sipMinAmount: freedom_sip_min_amt,
      };
    });
  };
};

interface IsFreedomEligible {
  (args: { fund: string; scheme: string; frequency: string; option: string }): (
    dispatch: any
  ) => Promise<boolean>;
}

export const isSchemeFreedomEligible: IsFreedomEligible = function (args) {
  return async function (dispatch: any) {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: "/FreedomSIPEligibleFlag",
          method: "GET",
          params: {
            fund: args.fund,
            scheme: args.scheme,
            frequency: args.frequency,
            opt: args.option,
          },
        },
      });
      const { DtData = [] } = response;
      const [flagDetails = {}] = DtData;
      const { freedom_ligibile_flag = "" } = flagDetails;
      return freedom_ligibile_flag === YES;
    } catch (error) {
      return false;
    }
  };
};
interface GetTenures {
  (args: { fund: string; frequency: string; scheme: string }): (
    dispatch: any
  ) => Promise<
    Array<{
      label: string;
      value: any;
      multiplier: number;
    }>
  >;
}
export const getSipTenures: GetTenures = function (params) {
  return async function (dispatch) {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: `/Ktrack_GetMinAmt`,
          params: {
            Fund: params.fund,
            Scheme: params.scheme,
            Trtype: "SIP",
            Frequency: params.frequency,
          },
          method: "GET",
        },
      });
      const { Table2 = [] } = response;
      return Table2.filter((ele: any) => ele.active === "Y").map(
        (tenure: any) => {
          return {
            label: `${tenure.sip_tenure} (in years)`,
            value: tenure.sip_tenure,
            multiplier: tenure.swp_percent,
          };
        }
      );
    } catch (error) {
      alert(`${error}`);
    }
  };
};

export type AmountKey = "amount" | "installmentAmount" | "units";

export interface Payload {
  [key: string]: any;
  investorName: string;
  pan: string;
  fund: string;
  scheme: string;
  plan: string;
  option: string;
  arnCode: string;
  subArn: string;
  euinDeclaration: string;
  dcr: string;
  userId: string;
  subBroker: string;
  euin: string;
  amount: number;
  remarks: string;
  sipFrequency: string;
  sipStartDate: string;
  sipEndDate: string;
  noOfInstallments: number;
  modeOfRegistration: string;
  installmentAmount: number;
  sipDay: number;
  mobile: string;
  familyMobileFlag: string;
  email: string;
  familyEmailFlag: string;
  transactionType: string;
  paymentMode: string;
  schemeName: string;
}
export interface CartItemSipNew {
  cartItemId: string;
  cartId: string;
  pan: string;
  arnCode: string;
  investorName: string;
  fund: string;
  investmentAmount: number;
  units: null;
  transactionType: "SIPN";
  paymentStatus: string;
  payload: Payload;
  ihno: number;
  status: string;
  mobile: string;
  email: string;
  createdAt: string;
}

interface AddToCartIhno {
  ihno: string;
  orderIds: [];
}

interface AddToCartOrderIds {
  ihno: "";
  orderIds: number[];
}

type AddToCartFromHistory = AddToCartIhno | AddToCartOrderIds;
export interface NewPUrchaseResponse {
  Dtinformation: NewPurchaseScheme[];
}

export interface NewPurchaseScheme {
  Scheme_Plan: string;
  Scheme_Desc: string;
  MinAmt: number;
  Plan_Desc: string;
  PlanDesc: string;
  combo_flag: string;
  combo_lable: string;
  combo_disclaimer: string;
  multiples?: number;
}
export interface UmrnRespone {
  Table: any;
  Table1: Array<{
    PAN: string;
    IHNO: number;
    NAME: null;
    "MOBILE NO": null;
    "BANK A/C NO": string;
    "BANK NAME": string;
    "TRANSACTION DATE": string;
    UMRNNO: string;
    "KOTM REGD STATUS": string;
    "REJ REASON": null;
    "MANDATE START DATE": string;
    "MANDATE END DATE": string;
    BRANCH: null;
    EMAIL: string;
    "MOBILE NO1": number;
    "Bank Flag": string;
    GM_UMRNNo: string;
    Amt: number;
    Mode: string;
  }>;
}
type GetUmrn = ({
  fund,
  pan,
  folio,
  modeOfRegistration,
}: {
  fund: string;
  pan: string;
  folio: number | string;
  modeOfRegistration: "AOTM" | "KOTM";
}) => (dispatch: any) => Promise<ReturnType<typeof mapUmrnResponse>[]>;

export const mapUmrnResponse = function (
  umrnItem: UmrnRespone["Table1"][number]
) {
  const {
    "MANDATE END DATE": endDate,
    "MANDATE START DATE": startDate,
    Amt: mandateLimit,
    UMRNNO: umrnNumber,
    "BANK A/C NO": bankAccountNumber,
    "BANK NAME": bankName,
  } = umrnItem;
  return {
    label: umrnNumber,
    value: umrnNumber,
    mandateLimit,
    startDate,
    endDate,
    bankAccountNumber,
    bankName,
  };
};

type CartCheckout = (args: {
  cartId: string;
  pan: string;
  arnCode: string;
  selectedCartItems: Array<string>;
  [x: string]: any;
}) => (dispatch: Dispatch<any>) => Promise<any>;

export interface UmrnOptions
  extends Array<ReturnType<typeof mapUmrnResponse>> {}
